import { NgModule } from '@angular/core';
import { UrlBuilderPipe } from './url-builder.pipe';

@NgModule({
  declarations: [UrlBuilderPipe],
  exports: [UrlBuilderPipe]
})
export class UrlBuilderModule {}
